import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinBy',
})
export class JoinByPipe implements PipeTransform {
  transform<T>(values: T[], key: keyof T, separator: string = ', '): string {
    return values
      .map((x) => x[key])
      .sort((a, b) => (a as string).localeCompare(b as string))
      .join(separator);
  }
}
